import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import { UserbackProvider } from "@userback/react";
import store from "newui/store";

const showUserback = true;

// identify your logged-in users (optional)
const userbackToken =
	process.env.REACT_APP_RFQ_USERBACK_TOKEN ||
	"10882|22399|rtG9AvxiLE9HeYKBKruB5db8d";
const user_data = {
	id: "123456",
	info: {
		name: "someone",
		email: "someone@example.com",
	},
};

// Create root instance
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	showUserback ? (
		<UserbackProvider
			token={userbackToken}
			options={{ user_data: user_data }}
		>
			<Provider store={store}>
				<App />
			</Provider>
		</UserbackProvider>
	) : (
		<Provider store={store}>
			<App />
		</Provider>
	)
);

if (module.hot) {
	module.hot.accept("./App", () => {
		root.render(
			showUserback ? (
				<UserbackProvider
					token={userbackToken}
					options={{ user_data: user_data }}
				>
					<Provider store={store}>
						<App />
					</Provider>
				</UserbackProvider>
			) : (
				<Provider store={store}>
					<App />
				</Provider>
			)
		);
	});
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
